import useLayoutAreaStyles from './styles';
import { LayoutAreaIconProps } from './types';

const ScreenLayoutIcon: React.FunctionComponent<LayoutAreaIconProps> = (props) => {
  const classes = useLayoutAreaStyles(props);
  const { index } = props;

  const renderLayoutArea = () => {
    return index === 3 ? (
      <div className={classes.containerArea}>
        <div
          className={classes.areaPlus}
          data-testid={`ghostInspectorTarget_Layout_${index}_0`}
        ></div>
        <div
          className={classes.areaPlus}
          data-testid={`ghostInspectorTarget_Layout_${index}_1`}
        ></div>
        <div
          className={classes.areaPlus}
          data-testid={`ghostInspectorTarget_Layout_${index}_2`}
        ></div>
        <div
          className={classes.areaPlus}
          data-testid={`ghostInspectorTarget_Layout_${index}_3`}
        ></div>
      </div>
    ) : (
      <div className={classes.area} data-testid={`ghostInspectorTarget_Layout_${index}`}></div>
    );
  };

  return renderLayoutArea();
};

export default ScreenLayoutIcon;
